import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '='
    },
    template: `
    <div class="heading01 type01">
        <h1>{{ 'performanceReviews' | translate }}</h1>
        <ul class="actions01">
            <li>
                <a class="btn filter" ng-click="vm.toggleFilter()">{{ 'performanceReview.Filter reviews' | translate }}</a>
            </li>
        </ul>
    </div>
    <review-filter-reviews
        show-filter="vm.showFilter"
        list="vm.list"
        filter="vm.filter"
        default-filter="vm.defaultFilter"
        classifiers="vm.classifiers"
    />
    <table class="data01">
        <thead>
            <tr>
                <th>{{ 'performanceReview.Employee' | translate }}</th>
                <th>{{ 'performanceReview.Position' | translate }}</th>
                <th>{{ 'performanceReview.Performance review status' | translate }}</th>
                <th>{{ 'performanceReview.Interview' | translate }}</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr ng-repeat="item in vm.list.items">
                <td>{{ item.user.displayName }}</td>
                <td>
                    <p ng-repeat="drl in item.userDrlsWithValue">
                        {{ drl.departmentName }}, {{ drl.roleName }}, {{ drl.levelName }}
                    </p>
                </td>
                <td>{{ vm.REVIEW_STATUS_ENUM.LABELS[item.status] }}</td>
                <td>{{ vm.MomentService.formatTimeStamp(item.reviewDate) }}</td>
                <td class="actions">
                    <a ng-if="!(item.archivedFileName && item.status === vm.REVIEW_STATUS_ENUM.KEYS.ARCHIVED)"
                     class="btn ico-view" ui-sref="authorized.review.manage({ id: item.id })">
                        {{ 'performanceReview.View performance review' | translate }}
                    </a>
                    <a ng-if="item.archivedFileName && item.status === vm.REVIEW_STATUS_ENUM.KEYS.ARCHIVED"
                       ng-click="vm.downloadReview(item.id)"
                       class="btn ico-view"
                     >
                        {{ 'performanceReview.View performance review' | translate }}
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
    <pagination list="vm.list"></pagination>
    `
})
export default class {
    constructor ($window, MomentService, ListFactory, REVIEW_STATUS_ENUM, USER_STATUS_ENUM, ReviewResource, AuthResource) {
        this.$window = $window;
        this.MomentService = MomentService;
        this.ListFactory = ListFactory;
        this.REVIEW_STATUS_ENUM = REVIEW_STATUS_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ReviewResource = ReviewResource;
        this.AuthResource = AuthResource;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.ReviewResource.indexManage.bind(this.ReviewResource));
        this.list.pagination.perPage = 50;
        this.defaultFilter = {
            isPerformanceReviewManager: true,
            expand: 'user,userDrlsWithValue',
            'employeeStatuses[]': [this.USER_STATUS_ENUM.KEYS.ACTIVE, this.USER_STATUS_ENUM.KEYS.NOT_STARTED]
        };
        this.filter = angular.copy(this.defaultFilter);
        this.list.fetch(this.filter);
    }

    toggleFilter () {
        this.showFilter = !this.showFilter;
    }

    downloadReview (id) {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}performance-review/performance-review/download-archived-file/${id}?tacToken=${token}`;
                this.$window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/list/index.js